import * as React from "react"
const ThirtyTwoOZIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinejoin="round"
      d="M9.125 3.5h6a.5.5 0 0 1 .5.5v1.5h-7V4a.5.5 0 0 1 .5-.5Z"
    />
    <rect
      width={9}
      height={15}
      x={7.625}
      y={5.5}
      stroke="#fff"
      strokeLinejoin="round"
      rx={0.5}
    />
    <path
      stroke="#fff"
      strokeLinecap="round"
      d="M14.125 8.5h2.5M14.125 17.5h2.5M14.125 14.5h2.5M14.125 11.5h2.5"
    />
  </svg>
)
export default ThirtyTwoOZIcon;
